import type { ComponentProps } from 'react'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import useIsHomePage from 'hooks/Navigation/useIsHomePage'
import IconButton from 'LuxKit/Button/IconButton'
import TextButton from 'LuxKit/Button/TextButton'
import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import TextLink from 'LuxKit/TextLink'

interface Props extends Pick<ComponentProps<typeof TextButton>, 'to' | 'href' | 'target'> {
  children: string
  desktopAsTextLink?: boolean
}

function CarouselViewAllLink({ children, desktopAsTextLink, ...linkProps }: Props) {
  const isHomePage = useIsHomePage()
  const textLink = desktopAsTextLink
    ? <TextLink wrap="no-wrap" {...linkProps}>{children}</TextLink>
    : <TextButton kind="tertiary" size="medium" {...linkProps}>{children}</TextButton>

  if (!isHomePage) {
    return textLink
  }

  return <>
    <CSSBreakpoint max="mobile" as="span">
      <IconButton kind="tertiary" size="medium" aria-label={children} {...linkProps}>
        <LineArrowRightIcon />
      </IconButton>
    </CSSBreakpoint>
    <CSSBreakpoint min="tablet" as="span">
      {textLink}
    </CSSBreakpoint>
  </>
}

export default CarouselViewAllLink
